export default __webpack_public_path__ + "static/screen-web-a44e3d7eedf935e2b505cbfcb8e5c070.webp";